<template>
  <div>
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view></router-view>
    <phone-dial-modal />
    <FloatingPhoneButton />
    <IncomingCallsAlert />
  </div>
</template>

<script>
import FloatingPhoneButton from './components/VoIP/FloatingPhoneButton.vue';
import IncomingCallsAlert from './components/VoIP/IncomingCallsAlert.vue';

export default {
  name: "App",
  components: {
    FloatingPhoneButton,
    IncomingCallsAlert,
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
